import { render, staticRenderFns } from "./ConfigModelosDocWizard.vue?vue&type=template&id=31177f8d&scoped=true&lang=pug&"
import script from "./ConfigModelosDocWizard.vue?vue&type=script&lang=js&"
export * from "./ConfigModelosDocWizard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigModelosDocWizard.vue?vue&type=style&index=0&id=31177f8d&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31177f8d",
  null
  
)

export default component.exports